export const popupsArr = [
  {
    text: 'С этого компьютера хакерам удалось пробраться в систему банка.',
  },
  {
    text: 'Давайте проверим настройки компьютера, чтобы понять, как им это удалось.',
    buttonTitle: 'Проверить',
  },
]
